<script src="verify-otp.component.ts"></script>
<div class="content-layout" [brightsideWebFb]="{ event_name: 'credit_otp' }">
  <bw-action-article-legacy>
    <ui-nav-exit-back *ngIf="!pageFromFullLayout" back-action-top [trackingDetail]="{ event_name: 'credit_otp_dismissed' }"></ui-nav-exit-back>
    <ui-nav-exit-back *ngIf="pageFromFullLayout" back-action-bottom [trackingDetail]="{ event_name: 'credit_otp_dismissed' }"></ui-nav-exit-back>

    <div header-title class="mb-sm">
      <typography-legacy title-medium>{{ 'CONFIRM_DEVICE' | translate }}</typography-legacy>
    </div>

    <div content-section>
      <form [formGroup]="codeForm">
        <div class="flex-row mb-md">
          <p class="secondary-text mr-xs" *ngIf="phoneNumber">
            {{ 'CONFIRM_DEVICE_DESC' | translate: {maskedPhone:phoneNumber|phone:true} }}
          </p>
          <bw-icon-legacy iconName="information" (click)="showThirdPartyBlurb = true"></bw-icon-legacy>
        </div>

        <bw-input-legacy
          [isCustomControl]="true"
          label="{{ 'CODE' | translate }}"
          inputError="code.invalid"
          [inputErrorText]="codeErrorText">
          <input type="text" class="body" formControlName="code" />
        </bw-input-legacy>

        <typography-legacy text-medium-regular>
          <a bw-anchor-legacy class="bs-blue brand"
             (click)="handleResendCtaClick()">
            {{ 'RESEND_CODE' | translate }}
          </a>
        </typography-legacy>
      </form>
    </div>

    <div footer-actions class="flex-row flex-item-flexible space-between">
      <div></div>
      <div class="flex-row row-reverse">
        <button
          bw-button-legacy
          type="submit"
          [brightsideWebFb]="{ event_name: 'credit_otp'}"
          [disabled]="codeForm.invalid || codeErrorText.length > 0"
          [processing]="processing"
          (click)="handleCtaClick()">
          {{ 'BUTTON_CONTINUE' | translate }}
        </button>

        <typography-legacy text-large-semibold *ngIf="!inOboarding">
          <a bw-anchor-legacy class="bs-blue brand pr-xl"
            (click)="handleSecondaryCtaClick()"
            [innerHTML]="'CONTACT_ASSISTANT' | translate">
            </a>
        </typography-legacy>
      </div>
    </div>
  </bw-action-article-legacy>
</div>

<bw-modal-legacy
  *ngIf="showThirdPartyBlurb"
  modalWidth="medium"
  [showCloseButton]="true"
  [brightsideWebFb]="{ event_name: 'identity_verification'}"
  (closeModal)="showThirdPartyBlurb = false; analytics.logEvent('identity_verification_dismissed')">
  <typography-legacy title-medium>{{ 'CREDIT_OTP_TITLE' | translate }}</typography-legacy>
  <div class="body">
    <typography-legacy class="body" text-large-regular color="var(--secondary-text)">
      {{ 'CREDIT_OTP_DESC' | translate }}
    </typography-legacy>
  </div>
  <footer class="footer">
    <div class="flex-row row-reverse"></div>
  </footer>
</bw-modal-legacy>

<bw-modal-legacy
  *ngIf="fourTwoNineError"
  modalWidth="medium"
  [brightsideWebFb]="{ event_name: 'error_shown', custom: { 'error id': 'credit_setup_invalid_data'}}">
  <typography-legacy title-medium>{{ 'ERROR_CREDIT_FAILED_TITLE' | translate }}</typography-legacy>
  <div class="body">
    <typography-legacy class="body" text-large-regular color="var(--secondary-text)">
      {{ 'ERROR_CREDIT_DATA_MISMATCH' | translate }}
    </typography-legacy>
  </div>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button
        bw-button-legacy
        (click)="mismatchContinue()">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>
